import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

const useUnreadCount = (enabled = true) => {
  const { data, ...args } = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const res = await Api.UnreadCount();
      return res.data.unreadCount;
    },
    enabled,
  });

  return { ...args, unreadCount: data ?? 0 };
};

export default useUnreadCount;
